export default __webpack_public_path__ + "navigation-examples-custom-banner-960-f350a2254b6c1e7efb43ac84ad8d053c.png";